import { Box, Text } from '@mantine/core';

/** A labelled value. Used for the settings a task is fixed to, and for a run's own details. */
export function Detail({ label, value }: { label: string; value: string }) {
  return (
    <Box>
      <Text size="xs" c="dimmed">
        {label}
      </Text>
      <Text size="xs">{value}</Text>
    </Box>
  );
}
